(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("clappr"));
	else if(typeof define === 'function' && define.amd)
		define(["clappr"], factory);
	else if(typeof exports === 'object')
		exports["DashShakaPlayback"] = factory(require("clappr"));
	else
		root["DashShakaPlayback"] = factory(root["Clappr"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__1__) {
return 